import(/* webpackMode: "eager" */ "/vercel/path0/src/app/offline/mafia/page.tsx");
